import { render, staticRenderFns } from "./compression-suggestion.vue?vue&type=template&id=4405ca00&scoped=true"
import script from "./compression-suggestion.vue?vue&type=script&lang=js"
export * from "./compression-suggestion.vue?vue&type=script&lang=js"
import style0 from "./compression-suggestion.vue?vue&type=style&index=0&id=4405ca00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4405ca00",
  null
  
)

export default component.exports